import React from "react";

// Small SVG percentage ring shared by the reports list and the Overview tab.
// Text fill is the theme's primary text variable (#e8e8e8 in dark mode), set
// via CSS so it works wherever the ring is placed, not just inside themed containers.
export default function CircleStat({ label, rate }) {
  const p = Math.max(0, Math.min(100, Math.round((rate || 0) * 100)));
  const r = 22, stroke = 6, size = (r + stroke) * 2;
  const c = 2 * Math.PI * r;
  const offset = c * (1 - p / 100);
  let color = "#2e7d32";
  if (p < 10) color = "#d32f2f"; else if (p < 25) color = "#f57c00"; else if (p < 50) color = "#fbc02d";
  return (
    <div className="circle-stat">
      <svg width={size} height={size} role="img" aria-label={`${label}: ${p}%`}>
        <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke="var(--gpt-seo-stat-track, #e5e7eb)" strokeWidth={stroke} />
        <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke={color} strokeWidth={stroke}
          strokeDasharray={c} strokeDashoffset={offset} strokeLinecap="round"
          transform={`rotate(-90 ${size / 2} ${size / 2})`} />
        <text x="50%" y="50%" dominantBaseline="middle" textAnchor="middle" fontSize="12"
          style={{ fill: "var(--gpt-seo-text-primary)" }}>{p}%</text>
      </svg>
      <div className="circle-stat-label">{label}</div>
    </div>
  );
}
